export default "__VITE_ASSET__fa67a512__"